import { ABILITIES, type AbilityId } from "@mucki/shared";

export interface AbilityBar {
  element: HTMLElement;
  /** Called when the server confirms a use; the sweep runs off the shared record. */
  startCooldown(abilityId: AbilityId, at: number): void;
  update(now: number, energy: number): void;
}

interface AbilitySlot {
  root: HTMLElement;
  cooldown: HTMLElement;
}

export function createAbilityBar(): AbilityBar {
  const element = document.createElement("div");
  element.className = "ability-bar";

  const slots = new Map<AbilityId, AbilitySlot>();
  const startedAt = new Map<AbilityId, number>();

  for (const ability of Object.values(ABILITIES)) {
    const root = document.createElement("div");
    root.className = "ability";

    const hotkey = document.createElement("div");
    hotkey.className = "ability-hotkey";
    hotkey.textContent = ability.hotkey;

    const name = document.createElement("div");
    name.className = "ability-name";
    name.textContent = ability.name;

    const cooldown = document.createElement("div");
    cooldown.className = "ability-cooldown";

    root.append(cooldown, hotkey, name);
    element.appendChild(root);
    slots.set(ability.id, { root, cooldown });
  }

  return {
    element,
    startCooldown: (abilityId, at) => startedAt.set(abilityId, at),
    update: (now, energy) => {
      for (const ability of Object.values(ABILITIES)) {
        const slot = slots.get(ability.id);
        if (!slot) continue;

        const began = startedAt.get(ability.id);
        const remaining =
          began === undefined ? 0 : Math.max(0, began + ability.cooldownMs - now);
        slot.cooldown.style.height = `${(remaining / ability.cooldownMs) * 100}%`;
        slot.root.classList.toggle("is-unaffordable", energy < ability.energyCost);
      }
    },
  };
}
